import {
  useModalOldContext,
  WSButton,
  WSButtons,
  WSElementProps,
  WSFormOld,
  WSModalOld,
  WSText,
  WSInputTextarea
} from "@wingspanhq/fe-component-library";
import { Payable, Payee } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { useHistory } from "react-router-dom";
import { WSErrorMessage } from "../../../components/WSErrorMessage/WSErrorMessage";
import { queriesPayableRows, queriesPayables } from "@query";
import { QUERY_PAYABLES } from "../../../query/payables/keys";

type Props = WSElementProps;

export const REJECT_PAYABLE_MODAL = "REJECT_PAYABLE_MODAL";

export const RejectPayableModal: React.FC<Props> = () => {
  const { closeModal } = useModalOldContext();
  const history = useHistory();
  const [rejectPayable, rejectPayableMeta] =
    queriesPayables.rejectPayable.useMutation({
      dependencies: [
        QUERY_PAYABLES,
        queriesPayableRows.searchPayableRows.queryKeyBase
      ]
    });

  return (
    <WSModalOld
      name={REJECT_PAYABLE_MODAL}
      size="S"
      onClose={() => {
        rejectPayableMeta.reset();
      }}
      title="Reject Payable"
    >
      {({
        payable,
        listName
      }: {
        payable?: Payable;
        payee?: Payee;
        listName?: "paid";
      }) => {
        return (
          <>
            <WSFormOld<{ comment: string }>
              onSubmit={({ comment }) => {
                if (payable) {
                  rejectPayable(
                    {
                      payableId: payable.id!,
                      rejectPayableRequest: { reason: comment }
                    },
                    {
                      onSuccess: () => {
                        closeModal(REJECT_PAYABLE_MODAL);
                        history.push(
                          `/member/invoices/payables${
                            listName ? `/${listName}` : ""
                          }`
                        );
                      }
                    }
                  );
                }
              }}
            >
              <WSText mb="XL">
                Indicate the reason for the reject in the field below
              </WSText>

              <WSFormOld.Field
                mb="XL"
                name="comment"
                component={WSInputTextarea}
              />

              <WSErrorMessage
                mb="XL"
                error={rejectPayableMeta.error}
                contextKey="DisputeInvoice"
              />

              <WSButtons format="modal">
                <WSButton
                  name="rejectPayable"
                  loading={rejectPayableMeta.isLoading}
                >
                  Reject payable
                </WSButton>
                <WSButton.Secondary
                  onClick={() => {
                    rejectPayableMeta.reset();
                    closeModal(REJECT_PAYABLE_MODAL);
                  }}
                  type="button"
                >
                  Cancel
                </WSButton.Secondary>
              </WSButtons>
            </WSFormOld>
          </>
        );
      }}
    </WSModalOld>
  );
};
